import React, {useEffect} from 'react'

export default function EmailPasswordSignin(props) {
    const [values, setValues] = React.useState({
      email: '',
      password: '',
      showPassword: false,
    });
    
    useEffect(() => {
      props.handleDataChange('email', values);
    }, [values]);
    
    const handleChange = (property) => (event) => {
        let value = event.target.value
        let id = event.target.id;
        singleErrorCheck(id, value);
        props.handleDataChange('email', values);
        setValues({ ...values, [property]: value });
    };

    const handleClickShowPassword = () => {
      setValues({ ...values, showPassword: !values.showPassword });
    };

    let errorStyle = (id, property, style) => {document.getElementById(`${id}`).style[property] = style}

    let errorTarget = (id, value) => {
        let errors = false;
        if(value.length < 1){
          errorStyle(`${id}-container`, 'border', '1px solid #ef4b4b')
          errors = true;
        } else if (id === 'email') { 
          if(!emailValidation(value)) {
            errorStyle(`${id}-container`, 'border', '1px solid #5e76e8')
            // errorStyle('3px solid #5e76e8')
            errors = true;
          } else {
            errorStyle(`${id}-container`, 'border', '')
            // errorStyle('');
          }
        } else {
          errorStyle(`${id}-container`, 'border', '')
          // errorStyle('');
        }
        return errors;
    }

    const singleErrorCheck = (target, value) => {
        errorTarget(target, value);
    }
    
    const emailValidation = (string) => {
        let mailFormat = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
        if(string.match(mailFormat)){
            return true;
        } else {
            return false;
        }
    }
    return (
        <form className="col s12">
            <div className="row get-email">
                <div className="input-field col s12 userCardNumber" id="email-container">
                    <input id="email" type="text" className="validate" onChange={handleChange('email')} value={values.email}/>
                    <label htmlFor="email">Email</label>
                </div>
            </div>
            <div className="row get-password">
                <div className="input-field col s12 userCardNumber" id="password-container">
                    <input id="password" type={values.showPassword ? "text" : "password"} className="validate" onChange={handleChange('password')}/>
                    <label htmlFor="password">Password</label>
                    <span className="show-hide-password waves-effect" onClick={handleClickShowPassword}><i className={`las la-eye${values.showPassword ? '' : '-slash'}`}></i></span>
                </div>
            </div>
      </form>
    )
}
